class SwatchesPicker extends HTMLElement {
  constructor() {
    super();

    this.handleOnButtonMoreClick = this.handleOnButtonMoreClick.bind(this);
  }

  connectedCallback() {
    this.swatches = this.querySelectorAll('a[data-swatch]');
    this.swatches.forEach((swatch) => {
      swatch.addEventListener('click', this.handleOnSwatchClick.bind(this));
    });
    this.buttonSwatchesMore = this.querySelectorAll(
      '[data-button-swatches-more]',
    );
    this.buttonCloseSwatchesMore = this.querySelector(
      '[data-button-close-swatches-more]',
    );
    this.moreSwatches = this.querySelector('[data-swatches-more]');

    this.buttonSwatchesMore.forEach((button) => {
      button.addEventListener('click', this.handleOnButtonMoreClick);
    });
    this.buttonCloseSwatchesMore.addEventListener(
      'click',
      this.handleOnButtonMoreClick,
    );
  }

  handleOnSwatchClick(event) {
    const deviceCanHover = window.matchMedia(
      '(hover: hover) and (pointer: fine)',
    ).matches;

    if (deviceCanHover) {
      return;
    }

    this.swatches.forEach((swatch) => {
      swatch.classList.toggle('is-pressed', swatch === event.target);
    });
  }

  handleOnButtonMoreClick(event) {
    const open = this.moreSwatches.classList.contains('hidden');

    this.buttonSwatchesMore.forEach((button) =>
      button.classList.toggle('hidden', open),
    );
    this.buttonCloseSwatchesMore.classList.toggle('hidden', !open);
    this.moreSwatches.classList.toggle('hidden', !open);
  }
}

customElements.define('swatches-picker', SwatchesPicker);
